import {
    GET_ORGANIZATIONS_FAILURE,
    GET_ORGANIZATIONS_REQUEST,
    GET_ORGANIZATIONS_SUCCESS
} from "../constants/organizationActionTypes";

const initialState = {
    organizations: [],
    organizationsLoaded: false,
    loading: {
        getOrganizations: false,
    },
    error: null
}

const organizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ORGANIZATIONS_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, getOrganizations: true },
                organizationsLoaded: false,
                error: null
            };
        case GET_ORGANIZATIONS_SUCCESS:
            return {
                ...state,
                organizations: action.payload.orgUnits,
                organizationsLoaded: true,
                loading: { ...state.loading, getOrganizations: false },
                error: null
            };
        case GET_ORGANIZATIONS_FAILURE:
            return {
                ...state,
                organizations: [],
                organizationsLoaded: false,
                loading: { ...state.loading, getOrganizations: false },
                error: action.payload
            };
        default:
            return state;
    }
}

export default organizationReducer;